import { render, staticRenderFns } from "./VerticalText.vue?vue&type=template&id=24a3c2e4&"
import script from "./VerticalText.vue?vue&type=script&lang=js&"
export * from "./VerticalText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports